import Box from "@mui/material/Box";

import { useDispatch, useSelector } from "react-redux";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";

import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import { actionInfoRoomIndexUpdated } from "./InfoRedux";
import BasicInfo from "./RoomInfoBasic";
import AdditionalInfo from "./RoomInfoAdditional";

const root_ = (theme) => ({
  backgroundColor: theme.palette.background.paper,
  width: "100%",
});

const tabs_ = (theme) => ({
  "& button.MuiTab-root": {
    minWidth: "auto !important",
  },
});

// Avoids a "Text is clipped when resized" complaint from Siteimprove.
const tab_ = (theme) => ({
  overflow: "auto",
});

export default function RoomInfo({ room }) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const tabIndex = useSelector((state) => state.infoReducer.roomInfoIndex);

  const handleChange = (_, newValue) => {
    dispatch(actionInfoRoomIndexUpdated(newValue));
  };
  const handleChangeIndex = (index) => {
    dispatch(actionInfoRoomIndexUpdated(index));
  };

  return (
    <Box sx={root_}>
      <AppBar position="static" color="default">
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="map layer tabs"
          sx={tabs_}
        >
          <Tab
            label="BASIC"
            sx={tab_}
            {...a11yProps(0)}
            data-testid="info-room-basic-tab"
          />
          <Tab
            label="ADDITIONAL"
            sx={tab_}
            {...a11yProps(1)}
            data-testid="info-room-additional-tab"
          />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={tabIndex}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={tabIndex} index={0} dir={theme.direction}>
          <BasicInfo room={room} />
        </TabPanel>
        <TabPanel value={tabIndex} index={1} dir={theme.direction}>
          <AdditionalInfo room={room} />
        </TabPanel>
      </SwipeableViews>
    </Box>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box style={{ padding: "16px" }}>{children}</Box>}
    </Typography>
  );
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
